import { Star } from "lucide-react";
import { REVIEWS } from "../../data/reviews";
import { Reveal, Eyebrow } from "./Reveal";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="text-center">
          <Eyebrow testId="reviews-eyebrow">Kind Words</Eyebrow>
          <h2 className="mx-auto mt-4 max-w-2xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-[#2C2520] sm:text-4xl lg:text-5xl">
            Loved by the people <span className="italic text-[#A35C45]">they were made for.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:gap-8 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 0.12} className="h-full">
              <figure
                data-testid={`review-card-${i}`}
                className="flex h-full flex-col rounded-2xl border border-[#E6DFD5] bg-[#FAF7F2] p-6 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(44,37,32,0.18)] sm:p-8"
              >
                <div className="flex gap-1 text-[#C88A75]" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1 font-serif text-lg font-medium italic leading-relaxed text-[#2C2520]">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-6 border-t border-[#E6DFD5] pt-4">
                  <p className="text-sm font-semibold text-[#2C2520]">{r.name}</p>
                  <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8C7A6B]">{r.item}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
